// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.addmore-relative {
  position: relative !important;
}

.addmore-btn {
  position: absolute;
  top: 10px;
  right: -160px
}

.tags {
  background: #3ac47d;
  padding: 10px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
}

.add-menu-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.addon-group {
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  /* margin-bottom: 20px; */
}

.addon-item {
  transition: all 0.2s ease-in-out;
}

.addon-item:hover {
  background-color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.price-input {
  width: 100px;
  text-align: right;
}

.text-primary {
  color: #0d6efd !important;
}

.relative-icon {
  position: relative;
}

.cross-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  color: #ff0707;
}

.sub-addon {
  display: flex;
  margin: 10px;
  padding: 20px;
  gap: 5px;
  align-items: center;
  background: #edeaea;
}

.sub-addon button {
  margin-top: 27px !important;
  height: 35px !important;

}

.inform-error {
  color: #db3c36;
  font-size: 12px;
}

.autocomplete-dropdown-container {
  z-index: 999 !important;
  color: #000 !important;
}

.autocomplete-dropdown-container {
  position: absolute;
  width: 100%;
  top: 50px;
}

.errcolor {
  font-size: 13px;
  color: red !important;
}

.modal-header .btn-close::before {
  content: "×";
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
  color: #000;
}

.hotdealscheck {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.hotdealscheck label {
  cursor: pointer;
  color: #3ea99f;
  font-size: 15px;
  font-weight: 500;
}

.hotdealscheck label input {
  cursor: pointer;
  margin-right: 3px;
  margin-top: 6px;
  height: 15px;
  width: 15px;
  padding: 10px;

}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;;AAEzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;;AAEf","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.addmore-relative {\n  position: relative !important;\n}\n\n.addmore-btn {\n  position: absolute;\n  top: 10px;\n  right: -160px\n}\n\n.tags {\n  background: #3ac47d;\n  padding: 10px;\n  color: #fff;\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.add-menu-btn {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.addon-group {\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  padding: 16px;\n  /* margin-bottom: 20px; */\n}\n\n.addon-item {\n  transition: all 0.2s ease-in-out;\n}\n\n.addon-item:hover {\n  background-color: #ffffff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  transform: translateY(-2px);\n}\n\n.price-input {\n  width: 100px;\n  text-align: right;\n}\n\n.text-primary {\n  color: #0d6efd !important;\n}\n\n.relative-icon {\n  position: relative;\n}\n\n.cross-icon {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  cursor: pointer;\n  color: #ff0707;\n}\n\n.sub-addon {\n  display: flex;\n  margin: 10px;\n  padding: 20px;\n  gap: 5px;\n  align-items: center;\n  background: #edeaea;\n}\n\n.sub-addon button {\n  margin-top: 27px !important;\n  height: 35px !important;\n\n}\n\n.inform-error {\n  color: #db3c36;\n  font-size: 12px;\n}\n\n.autocomplete-dropdown-container {\n  z-index: 999 !important;\n  color: #000 !important;\n}\n\n.autocomplete-dropdown-container {\n  position: absolute;\n  width: 100%;\n  top: 50px;\n}\n\n.errcolor {\n  font-size: 13px;\n  color: red !important;\n}\n\n.modal-header .btn-close::before {\n  content: \"×\";\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1;\n  color: #000;\n}\n\n.hotdealscheck {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.hotdealscheck label {\n  cursor: pointer;\n  color: #3ea99f;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.hotdealscheck label input {\n  cursor: pointer;\n  margin-right: 3px;\n  margin-top: 6px;\n  height: 15px;\n  width: 15px;\n  padding: 10px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
